import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {IPackage} from "../../models/Package";

interface IPackageSliceState {
    packages: IPackage[],
    packagesLoading: boolean
}

const initialState: IPackageSliceState = {
    packages: [],
    packagesLoading: true
}

const packageSlice = createSlice({
    name: "packageSlice",
    initialState,
    reducers: {
        setPackages: (state, action: PayloadAction<IPackage[]>) => {
            state.packages = action.payload;
            state.packagesLoading = false;
        },
    }
});

export const {setPackages} = packageSlice.actions;

export default packageSlice.reducer;